<script>
export default {
  name: 'ContentBox'
};
</script>

<template>
  <div class="content-box">
    <slot />
  </div>
</template>

<style lang="scss" scoped>
@import '@/styles/variables.scss';

.content-box {
  background: $--color-white;
  border-radius: 0.25rem;
  box-shadow: $--box-shadow-small;
  padding: 2rem 3rem;
  margin-bottom: 1rem;

  @include breakpoint('sm-and-down') {
    padding: 1.25rem 1.5rem;
  }
}
</style>
